import { AutoPickAttrProcessor } from "../processor/processors/AutoPickAttrProcessor.mjs";
import { ProductProcessorsEnum } from "../processor/ProductProcessorsEnum.mjs";
import { SizeProcessor } from "../processor/processors/SizeProcessor.mjs";
import { SizeHelper } from "../SizeHelper.mjs";
import { ProductContext } from "./ProductContext.mjs";
export class ProductWizardContext extends ProductContext {
    constructor() {
        super();
        this.attributesRequiredByWizard = ['size', 'imperial_units', 'shape'];
        this.neverDisable = ['quantity'];
        this.quantityAndPriceOptions = [];
        this.isBusy = false;
        this.sizeHelper = new SizeHelper(this.attrComputer, this.productItem);
        // Wizard Processors
        const autoPickProcess = new AutoPickAttrProcessor(['laminate'], this.cherryPicks, (attributeName) => !this.canAttrValuesBeDisabled(attributeName), (attributeName) => this.isAttributeRequired(attributeName));
        this.processors.registerProcessor(ProductProcessorsEnum.AUTOPICK, autoPickProcess);
        this.processors.registerProcessor(ProductProcessorsEnum.SIZE, new SizeProcessor(this.sizeHelper));
        // This means that "feature" and "ink" can't make "laminate" options constrained
        // For instance, when we have made a sticker with backprint in the editor
        // we still want to be able to choose from all the available laminates
        // TODO: Pass this as a argument and use it for the customer, ignore it for admin advanced mode.
        // TODO: Or instead of passing as argument, pass it as a part of the ProductAttrInterface from the backend
        this.attrEvaluator.ignoreConstraintsFromTo('feature', 'laminate');
        this.attrEvaluator.ignoreConstraintsFromTo('ink', 'laminate');
        //		this.attributesModel.conditionsEvaluater.ignoreConstraintsFromTo( "ink", "laminate" );
    }
    resetQuantity(quantityAndPriceOptions) {
        this.quantityAndPriceOptions = quantityAndPriceOptions;
        const defaultOption = this.quantityAndPriceOptions.find((option) => option.quantity !== 0);
        const defaultQuantity = defaultOption ? defaultOption.quantity : 0;
        if (!this.cherryPicks.hasAttribute('quantity') && defaultQuantity) {
            this.productItem.setAttribute('quantity', defaultQuantity);
        }
    }
    canAttrValuesBeDisabled(attributeName) {
        return this.neverDisable.indexOf(attributeName) < 0;
    }
    /**
     * A attribute can be required by the product service, to determine if a product is valid.
     * And there is some attribute we require by the Sticker Wizard.
     *
     * @param attributeName
     */
    isAttributeRequired(attributeName) {
        return this.attrComputer.isRequired(attributeName) || this.attributesRequiredByWizard.indexOf(attributeName) >= 0;
    }
    getAttributeOptions(attributeName, disableOutOfStockValues = true) {
        const currentValue = this.productItem.getAttribute(attributeName);
        const optionValues = this.attrComputer.getSuggestedValues(attributeName);
        if (this.attrComputer.isDynamicValue(attributeName)) {
            const value = this.attrComputer.parseAttribute(attributeName, currentValue);
            if (value !== null && !Array.isArray(value) && !optionValues.includes(value)) {
                optionValues.push(value);
            }
        }
        const disabledValues = [
            ...(this.canAttrValuesBeDisabled(attributeName) ? this.attrComputer.getConstrainedValues(attributeName) : []),
            ...(disableOutOfStockValues ? this.attrComputer.getOutOfStockValues(attributeName) : []),
        ];
        const icons = this.attrComputer.getIcons(attributeName);
        const options = optionValues.map((value) => {
            var _a;
            return ({
                value,
                disabled: disabledValues.includes(value),
                icon: (_a = icons[value.toString()]) !== null && _a !== void 0 ? _a : null,
                selected: Array.isArray(currentValue) ? currentValue.includes(value) : String(currentValue) === String(value),
                out_of_stock: this.attrComputer.isOutOfStock(attributeName, value),
            });
        });
        return this.sortOptions(attributeName, options);
    }
    sortOptions(attributeName, options) {
        const sorted = options.reduce((acc, option) => {
            if (option.disabled) {
                acc.low.push(option);
            }
            else if (this.attrComputer.hasBeenFiltered(attributeName) && !this.attrComputer.isInFilteredValues(attributeName, option.value)) {
                acc.medium.push(option);
            }
            else {
                acc.high.push(option);
            }
            return acc;
        }, { high: [], medium: [], low: [] });
        return [...sorted.high, ...sorted.medium, ...sorted.low];
    }
}
